module.exports = __webpack_public_path__ + "static/media/about_banner.b7524c08.jpg";